import { HiArrowRight } from "react-icons/hi";
import { Link } from "react-router-dom";

interface ReadyToAutomateProps {
    className?: string;
}

export default function ReadyToAutomate({
    className = "",
}: ReadyToAutomateProps) {
    return (
        <section className={`bg-web-background  ${className}`}>
            <div className="relative mx-auto max-w-5xl overflow-hidden rounded-[32px] border border-white/10 bg-web-background px-6 py-16 text-center">
                {/* Green Glow */}
<div className="absolute -inset-20 bg-web-radial-glow-secondary" />
                <div className="relative z-10 flex flex-col items-center">
                    <img
                        src="/images/whtsappLogo.svg"
                        alt="WhatsApp"
                        className="mb-6 h-14 w-14"
                    />

                    <h2 className="text-4xl font-bold text-white md:text-5xl">
                        Ready to{" "}
                        <span className="text-web-primary">
                            automate?
                        </span>
                    </h2>

                    <p className="mx-auto mt-4 max-w-xl text-base leading-7 text-white/70">
                        Spin up your workspace in 60 seconds. Free forever for
                        <br />
                        the first 100 messages.
                    </p>

                    <Link
                        to="/login"
                        className="mt-10 inline-flex items-center gap-2 rounded-xl bg-web-primary px-6 py-4 font-medium text-black shadow-web-glow transition-all hover:bg-web-secondary hover:text-white"
                    >
                        Get Started
                        <HiArrowRight className="text-black text-base" />
                    </Link>
                </div>
            </div>
        </section>
    );
}